export default {
  "content": "<title>Volume Off</title><path d=\"M237.65 176.1H144v159.8h93.65L368 440V72L237.65 176.1z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};